import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useBreakoutGet = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["breakoutReport", filters],
    () => {
      const encodedEvents = filters.events.map(encodeURIComponent).join(";");
      const eventSetSegment = `/eventSetId/${filters.eventSetId ?? "null"}`;
      return makeAuthedRequest(
        `v1/reporting/breakout-sessions/type/${filters.type}/year/${filters.year}/eventId/${encodedEvents}${eventSetSegment}`,

        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
